import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export function BaseLogo(t0) {
  const $ = _c(19);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <circle className="fill-black/10 dark:fill-white/10" cx={12} cy={12} r={12} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== fill) {
    t6 = fillVariants({
      fill
    });
    $[9] = fill;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== fillAttribute || $[12] !== t6) {
    t7 = <path className={t6} d="M5.4 6.6C5.4 5.937258 5.937258 5.4 6.6 5.4H17.4C18.062742 5.4 18.6 5.937258 18.6 6.6V17.4C18.6 18.062742 18.062742 18.6 17.4 18.6H6.6C5.937258 18.6 5.4 18.062742 5.4 17.4V6.6Z" fill={fillAttribute} />;
    $[11] = fillAttribute;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== className || $[15] !== rest || $[16] !== t4 || $[17] !== t7) {
    t8 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t5}{t7}</svg>;
    $[14] = className;
    $[15] = rest;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}